export const BACKOFFICE_ORGANIZATIONS_EMPLOYEE_CENTER = {
  DESCRIPTION: 'Elige qué documentos muestra esta organización a sus empleados en el Employee Center.',
  VISIBLE_TOOLTIP:
    'Activar un documento lo hace elegible. Llega a los empleados cuando está traducido al idioma ' +
    'de la organización y tiene una versión aprobada, o un enlace de documento utilizable en ' +
    'organizaciones que siguen en Drive.',
  ALL_DEPARTMENTS: 'Todos los departamentos',
  NO_APPROVED_VERSION: 'Activado, pero aún no visible: sin versión aprobada',
  MISSING_TRANSLATION: 'Activado, pero aún no visible: sin traducción en el idioma de la organización',
  ENABLED_COUNT: '{count} visibles para empleados',
  HIDDEN_BY_FILTER: '{count} activados fuera de este filtro',
  NEVER_REVIEWED: '{count} sin revisar',
  NEVER_REVIEWED_OTHER_TYPES: 'Hay documentos sin revisar en {count} tipos más',
  SHOW_ALL_TYPES: 'Ver todos los tipos',
  ENABLE_ALL_IN_VIEW: 'Activar todo lo mostrado',
  ENABLING: 'Activando...',
  ALL_TYPES: 'Todos los tipos',
  SEARCH_PLACEHOLDER: 'Buscar por código o nombre...',
  LOADING: 'Cargando...',
  REFRESH: 'Actualizar',
  EMPTY: 'Ningún documento coincide.',
  TABLE: {
    CODE: 'Código',
    NAME: 'Nombre',
    TYPE: 'Tipo',
    STATUS: 'Estado',
    VISIBLE: 'Employee Center',
    DEPARTMENTS: 'Departamentos',
  },
  SNACKBAR: {
    SAVED: 'Cambios guardados',
  },
}
